import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/login';
import CreateNewPassword from './pages/login/CreateNewPassword';
import UpdateProfile from './pages/login/UpdateProfile';
import ValidateOTP from './pages/login/ValidateOTP';
import ValidatePassword from './pages/login/ValidatePassword';
import ValidatePhoneNumber from './pages/login/ValidatePhoneNumber';
import buildTimeConfig from '../config/buildtime.config';
import CreateNewBusinessAccount from './pages/login/CreateNewBusinessAccount';
import localization from './localization';
import MagicLink from './pages/login/MagicLink';
import './app.bootstrap';
import { useGA } from './utilities/useGA';

const AppContent = () => {
  useGA();
  return (
    <Routes>
      <Route path={'/'} element={<LoginPage root />}>
        <Route path="" element={<ValidatePhoneNumber />} />
        <Route path="magic-link" element={<MagicLink/>}/>
      </Route>
      <Route path={'/'} element={<LoginPage />}>
        <Route path="update-profile" element={<UpdateProfile />} />
        <Route path="create-password" element={<CreateNewPassword />} />
        <Route path="enter-password" element={<ValidatePassword />} />
        <Route path="enter-otp" element={<ValidateOTP />} />
        <Route path="register" element={<CreateNewBusinessAccount />} />
      </Route>
    </Routes>
  );
};

const App = () => {
  const appBaseRouting = buildTimeConfig.appRoutingBase;
  localization.init();
  return (
    <>
      <Router basename={appBaseRouting}>
        <AppContent />
      </Router>
    </>
  );
};

export default App;
